import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {getRouteUrlWithQuery} from "./get_route_url_with_query";

export const redirectWithoutFirstPage = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const {page: strPage, ...restQuery} = ctx.route.query;
    const intPage = parseInt(strPage as string, 10);
    if (!Number.isNaN(intPage) && intPage === 1) {
        dispatch(enable301ResponseState(getRouteUrlWithQuery(ctx, restQuery)));
        return false; // stop data-fetcher
    }
    return true; // continue data-fetcher
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {getRouteUrlWithQuery} from "./get_route_url_with_query";

export const redirectWithoutFirstPage = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const {page: strPage, ...restQuery} = ctx.route.query;
    const intPage = parseInt(strPage as string, 10);
    if (!Number.isNaN(intPage) && intPage === 1) {
        dispatch(enable301ResponseState(getRouteUrlWithQuery(ctx, restQuery)));
        return false; // stop data-fetcher
    }
    return true; // continue data-fetcher
};
